import React from "react"

function IconArrowsExchangeCircle({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="arrows-exchange-circle"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-arrows-exchange-circle"
      {...props}
    >
      <path
        d="M12.14 2.302c5.433 0 9.837 4.404 9.837 9.837s-4.404 9.838-9.837 9.838-9.838-4.405-9.838-9.838c0-5.432 4.405-9.837 9.838-9.837zm0 1.31a8.529 8.529 0 1 0 0 17.057 8.529 8.529 0 0 0 0-17.058zm.998 8.863a.655.655 0 0 1 .835-.075l.09.075 2.638 2.638.075.09a.655.655 0 0 1 0 .745l-.075.09-2.638 2.639-.09.075a.655.655 0 0 1-.745 0l-.09-.075-.076-.09a.655.655 0 0 1 0-.745l.076-.09 1.518-1.522H8.19l-.106-.009a.655.655 0 0 1 0-1.292l.106-.008h6.47l-1.521-1.52-.076-.09a.655.655 0 0 1 .076-.836zm-1.856-6.829c.227.227.252.58.076.835l-.076.09-1.522 1.52h6.47a.655.655 0 0 1 .107 1.301l-.106.009H9.762l1.52 1.521c.227.227.252.58.076.835l-.076.09a.655.655 0 0 1-.835.076l-.09-.076L7.718 9.21a.655.655 0 0 1-.076-.835l.076-.09 2.637-2.638a.655.655 0 0 1 .926 0z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconArrowsExchangeCircle
